import { Injectable, inject } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { Tost, TostPositionEnum, TostTypeEnum } from '../shared/models/tostes.model';
import { toSignal } from '@angular/core/rxjs-interop';
import { map, take, timer } from 'rxjs';
import { filter } from 'country-codes-list';

export interface TostesState {
  readonly tostes: Tost[] | null;
}

@Injectable({ providedIn: 'root' })
export class TostesStore extends ComponentStore<TostesState> {
  readonly tostes$ = this.select(x => x.tostes);
  readonly allTostesSig$ =toSignal(this.select(x => x.tostes)) ;
  readonly tostesSig$ = toSignal(this.tostes$.pipe(map(x=>x?.filter(x=>x.zIndex ==undefined))));
  readonly tostesSigHigh$ = toSignal(this.tostes$.pipe(map(x=>x?.filter(x=>x.zIndex !=undefined))));
  constructor() {
    super({ tostes:null })
  }

  readonly updateTostes = this.updater((state, tost: Tost) => {
    return {
      ...state,
      tostes: [...state.tostes ?? [], tost]
    }
  })

  addTost(tost: Tost): void {
    this.updateTostes(tost);
    if (tost.seconds) {
      timer(tost.seconds * 1000)
        .pipe(take(1))
        .subscribe(() => {
          this.removeTost(tost);
        });
    }
  }
  readonly removeAllTost = this.updater((state,type:TostTypeEnum| null) => {
    return {
      ...state,
      tostes: [...state.tostes?.filter(f=>f.type!=type && type!=null)??[]]
    }
  })

  removeTost(tost: Tost): void {
    const index = this.allTostesSig$()?.indexOf(tost);
    if (index != undefined && (index != -1)) {
      const updatedTostes = [...this.allTostesSig$() ?? []];
      updatedTostes.splice(index, 1);
      this.patchState({ tostes: updatedTostes });
    }
  }
  removeTostByGuid(guid: string): void {
    const updatedTostes = [...this.allTostesSig$()?.filter(t => t.guid != guid) ?? []];
    this.patchState({ tostes: updatedTostes });
  }

  // updateLoadTost(guid: string, newMessage: { en: string, he: string }, newType: TostTypeEnum, seconds?: number): void {
  //   const updatedTostes = [...this.tostesSig$()?.map(t => {
  //     if (t.guid == guid) {
  //       return { ...t, message: newMessage, type: newType, seconds }
  //     }
  //     else return t;
  //   }) ?? []];
  //   this.patchState({ tostes: updatedTostes });
  //   if (seconds) {
  //     // timer(seconds * 1000)
  //     //   .pipe(take(1))
  //     //   .subscribe(() => {
  //     //     this.removeTostByGuid(guid);
  //     //   });
  //   }
  // }

  generateGuid(): string {
    // Simple implementation of GUID generation
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
}